import React from 'react';
import { cn } from '../../lib/cn';

// Dark slate→brand gradient hero used at the top of Command Center pages.
export default function PageHeader({
  eyebrow,
  title,
  subtitle,
  icon: Icon,
  pills,
  actions,
  className
}) {
  return (
    <div
      className={cn(
        'relative overflow-hidden rounded-3xl bg-gradient-to-br from-slate-950 via-slate-900 to-brand-800 text-white px-6 py-6 sm:px-8 sm:py-7 shadow-pop',
        className
      )}
    >
      {/* decorative glow */}
      <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-brand-500/30 blur-3xl" />
      <div className="pointer-events-none absolute -left-12 bottom-0 h-40 w-40 rounded-full bg-sky-500/20 blur-3xl" />

      <div className="relative flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div className="min-w-0">
          <div className="flex items-center gap-2.5">
            {Icon ? (
              <span className="h-9 w-9 rounded-xl bg-white/10 border border-white/15 inline-flex items-center justify-center backdrop-blur">
                <Icon className="h-4.5 w-4.5" />
              </span>
            ) : null}
            {eyebrow ? (
              <span className="text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-200">
                {eyebrow}
              </span>
            ) : null}
          </div>
          <h1 className="mt-2 text-[24px] sm:text-[28px] font-semibold tracking-tight leading-tight">
            {title}
          </h1>
          {subtitle ? (
            <p className="mt-1.5 text-[13.5px] text-slate-300 max-w-2xl">{subtitle}</p>
          ) : null}
          {pills && pills.length ? (
            <div className="mt-4 flex flex-wrap items-center gap-2">{pills}</div>
          ) : null}
        </div>
        {actions ? <div className="flex items-center gap-2 shrink-0">{actions}</div> : null}
      </div>
    </div>
  );
}
